import script from "./PdfPictureSvg.vue?vue&type=script&lang=ts&setup=true"
export * from "./PdfPictureSvg.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__